/**
 * FRONT-3164: a chat or a Build in its own browser window, showing only that
 * conversation — no sidebar, no top bar (`routes/popout.tsx`).
 *
 * The address names the conversation, so the browser window can be reloaded,
 * bookmarked or moved to another screen and still open the same one.
 */
export type PopOutKind = 'chat' | 'build';

export function popOutUrl(kind: PopOutKind, id: string, title?: string | null): string {
  const q = title ? `?title=${encodeURIComponent(title)}` : '';
  return `/popout/${kind}/${encodeURIComponent(id)}${q}`;
}

/**
 * The browser window's name: opening the same conversation twice brings its
 * existing window forward instead of a second copy.
 */
export function popOutWindowName(kind: PopOutKind, id: string): string {
  return `eddy-${kind}-${id.replace(/[^A-Za-z0-9_-]/g, '_')}`;
}

/** Read back what `popOutUrl` wrote; null for anything else. */
export function parsePopOutPath(kind: string | undefined, id: string | undefined): { kind: PopOutKind; id: string } | null {
  if ((kind !== 'chat' && kind !== 'build') || !id) return null;
  return { kind, id };
}
